import jwtDefaultConfig from '@core/auth/jwt/jwtDefaultConfig'

/**
 * Decodifica o payload (2º segmento) de um JWT sem validar assinatura.
 * Uso típico: leitura de claims no cliente (a API continua sendo a fonte de verdade para autorização).
 *
 * @param {string|null|undefined} token JWT completo
 * @returns {Record<string, unknown>|null} Objeto do payload ou null se inválido
 */
export function decodeJwtPayload(token) {
  if (!token || typeof token !== 'string') return null
  const parts = token.split('.')
  if (parts.length < 2) return null
  try {
    const json = base64UrlToUtf8(parts[1])
    return JSON.parse(json)
  } catch {
    return null
  }
}

function base64UrlToUtf8(segment) {
  let base64 = segment.replace(/-/g, '+').replace(/_/g, '/')
  const pad = base64.length % 4
  if (pad) base64 += '='.repeat(4 - pad)
  const binary = atob(base64)
  try {
    return decodeURIComponent(
      binary
        .split('')
        .map(c => `%${(`00${c.charCodeAt(0).toString(16)}`).slice(-2)}`)
        .join(''),
    )
  } catch {
    return binary
  }
}

/**
 * Payload do access token armazenado (mesma key que `useJwt` / `jwtDefaultConfig`).
 */
export function getAccessTokenPayload() {
  const token = localStorage.getItem(jwtDefaultConfig.storageTokenKeyName)
  return decodeJwtPayload(token)
}

/**
 * CustomerId do usuário logado a partir do JWT (claims comuns em APIs .NET / custom).
 */
export function getCustomerIdFromAccessToken() {
  const payload = getAccessTokenPayload()
  if (!payload || typeof payload !== 'object') return null
  const id =
    payload.customerId ??
    payload.CustomerId ??
    payload.customerid ??
    payload.trackingcustomerid ??
    payload.customer_id ??
    null
  if (id === null || id === undefined) return null
  return id
}

/**
 * Verifica se o customer deve receber o evento conforme `customersToNotify`.
 *
 * @param {unknown} customersToNotify Lista de IDs (ou vazia)
 * @param {unknown} customerId ID do usuário logado
 */
export function isCustomerInCustomersToNotify(customersToNotify, customerId) {
  if (!Array.isArray(customersToNotify)) return false
  if (customerId === null || customerId === undefined || customerId === '') return false
  const needle = String(customerId)
  return customersToNotify.some(entry => String(entry) === needle)
}
